<div class="text-center">
  <img src="./assets/Images/Logo2.svg" alt="Logo">
</div>
<div class="mobile-responsive">
  @if (!isFormSend) {
    <div class="card col-lg-3 col-11 mx-auto">
      <div class="card-body">
        <h4>Passwort wiederherstellen</h4>
        <p class="fs-12">Geben Sie hier die Emailadresse ein, mit der Sie sich registriert haben, und wir senden Ihnen einen Link zum Zurücksetzen des Passworts.</p>
        <form [formGroup]="recoveryForm" class="recoveryForm" (ngSubmit)="onSubmit()">
          <label class="form-label w-100">
            <span>Email<span class="required">*</span></span>
            <input type="text" formControlName="email" class="form-control" placeholder="Ihre Email"
              [style]="(recoveryForm.get('email')!.hasError('required') || recoveryForm.get('email')!.hasError('pattern')) && recoveryForm.get('email')!.touched ? 'padding-left: 2.25rem;' : '' "
              [ngClass]="(recoveryForm.get('email')!.hasError('required') || recoveryForm.get('email')!.hasError('pattern')) && recoveryForm.get('email')!.touched ? 'invalid' : '' "
              >
            @if ((recoveryForm.get('email')!.hasError('required') || recoveryForm.get('email')!.hasError('pattern')) && recoveryForm.get('email')!.touched) {
              <i class="icon-cancel"></i>
            }
            @if (recoveryForm.get('email')!.hasError('required') && recoveryForm.get('email')!.touched) {
              <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Dieses Feld ist erforderlich.</span>
            }
            @if (recoveryForm.get('email')!.hasError('pattern') && recoveryForm.get('email')!.touched) {
              <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Falsche E-Mail.</span>
            }
          </label>
          <button type="submit" class="btn btn-primary d-block mx-auto submit-button" [disabled]="recoveryForm.invalid">Passwort zurücksetzen</button>
        </form>
      </div>
    </div>
  }
  @if (isFormSend) {
    <div class="card col-lg-3 col-11 mx-auto info-form">
      <div class="card-body">
        <h4>Passwort wiederherstellen</h4>
        <div class="card check-email-message">
          <div class="grid">
            <span class="icon-check-circle mt-1 fs-20"></span>
            <span class="mb-0 fs-14">
              Wenn der Benutzer "{{email}}" existiert, wurde ein Link zum Zurücksetzen des Passworts an diese Adresse gesendet.
              Falls Sie die E-Mail nicht erhalten haben oder weiterhin Probleme beim Zugriff haben, wenden Sie sich bitte an Ihren IT-Administrator.
            </span>
          </div>
        </div>
      </div>
    </div>
  }
  <div class="text-center mt-md-4 link">
    <span class="link-btn" (click)="GoToLogin()">Zurück zum Login</span>
  </div>
  <div class="text-center link">
    <a [href]="'https://www.ing-plus.de/datenschutz'" target="_blank" class="link-btn no-decoration">Datenschutzerklärung</a> <span class="link-btn"> |</span>
    <a [href]="'https://www.ing-plus.de/impressum'" target="_blank" class="link-btn no-decoration ml-1">Impressum </a>
  </div>

